import store from '@/components/facet/store'
import updateUrl from '@/components/facet/update-url'

const updatePageWithoutRefresh = async () => {
  const { tagUids } = store.getters
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
  store.dispatch('resetCards')
  store.dispatch('showLoader')
  const { state } = store
  await store.dispatch('loadCards', { tagUids })
  updateUrl.save(state)
  store.dispatch('hideLoader')
}

export default {
  async updatePage() {
    const { isFacet0, tagUids } = store.getters
    const { state } = store
    if (isFacet0) {
      store.dispatch('showLoader')
      store.dispatch('resetCards')
      updateUrl.reload()
    } else if (state.isFacetPage) {
      await updatePageWithoutRefresh()
    } else {
      store.dispatch('setIsNotFacetRedirecting')
      await store.dispatch('getFacetSlug', { tagUids })
      updateUrl.openRecipe(state)
    }
  }
}
